

import { Menu, Transition } from '@headlessui/react'
import { Fragment, } from 'react'
import { Link } from 'react-router-dom'

type ItemProps = {
    label: string,
    icon?: React.ReactElement,
    isDivider?: boolean,
    onClickItem?: () => void,
    asLink?: boolean,
    link?: string
}

type Props = {
    items: Array<ItemProps>,
    children: React.ReactNode,

}

export default function CustomDropdown(props: Props) {
    return (
        <div className="  text-right relative">
            <Menu as="div" className="relative inline-block text-left">
                <div>
                    <Menu.Button className="inline-flex w-full justify-center ">
                        {props.children}

                    </Menu.Button>
                </div>
                
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"

                >
                    <div className='absolute z-full'>
                        <Menu.Items className="fixed left-0  mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none bg-white z-full">

                            {props.items.map((item, index) => {


                                return (
                                    <div className="px-1 py-1 " key={index+"customDropdown"}>
                                        <Menu.Item key={"menuitem " + index}  >
                                            {({ active }) => item.asLink ? (
                                                <Link  to={item.link ||""}
                                                    className={`${active ? 'bg-gray-100 text-black' : 'text-gray-900'
                                                        } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                                                >
                                                    {item.icon && item.icon}
                                                    <span className='ml-2'>
                                                        {item.label}
                                                    </span>

                                                </Link>
                                            ) : (
                                                <button onClick={item.onClickItem}
                                                    className={`${active ? 'bg-gray-100 text-black' : 'text-gray-900'
                                                        } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                                                >
                                                    {item.icon && item.icon}
                                                    <span className='ml-2'>
                                                        {item.label}
                                                    </span>

                                                </button>
                                            )}
                                        </Menu.Item>
                                    </div>
                                );
                            })}



                        </Menu.Items>
                    </div>
                </Transition>
            </Menu>
        </div>
    )
}
